export default __webpack_public_path__ + "static/media/emptyHolder.00391ec3.svg";